// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as KnowledgeBaseRouteImport } from './routes/knowledge-base'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DataHandlingRouteImport } from './routes/data-handling'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BespokeRouteImport } from './routes/bespoke'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountSyncSubscribersRouteImport } from './routes/account.sync-subscribers'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopHandleRouteImport } from './routes/shop.$handle'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const KnowledgeBaseRoute = KnowledgeBaseRouteImport.update({
            id: '/knowledge-base',path: '/knowledge-base',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DataHandlingRoute = DataHandlingRouteImport.update({
            id: '/data-handling',path: '/data-handling',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BespokeRoute = BespokeRouteImport.update({
            id: '/bespoke',path: '/bespoke',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccountSyncSubscribersRoute = AccountSyncSubscribersRouteImport.update({
            id: '/account/sync-subscribers',path: '/account/sync-subscribers',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ShopRoute
          })
const ShopHandleRoute = ShopHandleRouteImport.update({
            id: '/$handle',path: '/$handle',getParentRoute: () => ShopRoute
          })





const ShopRouteChildren = {
  ShopHandleRoute: ShopHandleRoute,ShopIndexRoute: ShopIndexRoute
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BespokeRoute: BespokeRoute,ContactRoute: ContactRoute,DataHandlingRoute: DataHandlingRoute,FaqRoute: FaqRoute,KnowledgeBaseRoute: KnowledgeBaseRoute,PrivacyRoute: PrivacyRoute,QuizRoute: QuizRoute,ShopRoute: ShopRouteWithChildren,UnsubscribeRoute: UnsubscribeRoute,AccountSyncSubscribersRoute: AccountSyncSubscribersRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)